import { Component, OnInit } from '@angular/core';
import { IsLoadingService } from '@modules/common/services/is-loading.service';

@Component({
    selector: 'app-loading-overlay',
    templateUrl: './loading-overlay.component.html',
    styleUrls: ['./loading-overlay.component.scss'],
})
export class LoadingOverlayComponent implements OnInit {
    constructor(private _isLoadingService: IsLoadingService) { }

    public ngOnInit(): void {
        this._isLoadingService.observable.subscribe(x => {
            this.isLoading = x;
        });
    }

    public isLoading: boolean = false;
}
